const getTotalLessons = (el) => {
    return el.children.filter((baby) => baby.type === 'post').length;
};

const getCompletedLessons = (el) => {
    return el.children.filter(
        (baby) => baby.type === 'post' && baby.is_completed
    ).length;
};

export {
    getTotalLessons,
    getCompletedLessons
}